import Lottie from "lottie-react";
import Bot from "../../Bot.json";

export const BotAnimation = () => (
  <Lottie animationData={Bot} loop={true} style={{ width: 200, height: 200 }} />
);
